<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://',  v-if='params')
            slot(name='multiplayer')
            template(v-if='!homework  ||  homework.editable  ===  undefined  ||  (homework  &&  (homework.editable  ||  usersIds))')
                .form__field
                    label.form__label
                        |  {{  $i18n.t('trainer.trainer_gameFormSetting_numOfExamples')  }}
                    .form__field-body.form-container__select-examples
                        cs-spin-input(
                            :value="params.amountOfExamples",
                            :max="examples",
                            :min="1",
                            :disabled="params && (params.infinityAmountOfExamples || !!params.timeLimit)",
                            @increase="increaseExamples",
                            @decrease="decreaseExamples",
                            @input="params.amountOfExamples = $event",
                        )
                        .form-container__select-infinity-mode(v-if="gameMode && gameMode === 'free-game'")
                            cs-checkbox#infinityAmountOfExamples.form-container__checkbox(
                                v-model="params.infinityAmountOfExamples"
                                :checked="params && params.infinityAmountOfExamples"
                                :disabled="params && !!params.dictation"
                            )
                            svg-icon.form-container__svg-icon(name="infinity" :aria-hidden="true" size="big")
                .form__field(v-if="gameMode  !==  'course'")
                    label.form__label
                        |  {{  $i18n.t('trainer.trainer_gameFormSetting_mode')  }}
                    .form__field-body
                        cs-multiselect(
                            :multiple='false',
                            :options='modes',
                            label='label',
                            :show-labels='false',
                            :allow-empty='false',
                            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseMode')",
                            :value="{label:  $i18n.t('trainer')[params.mode],  value:  params.mode}",
                            @select='selectMode'
                        )
                .form__field.checkbox(v-if="gameMode  ===  'free-game'")
                    label.form__label.checkbox__label
                        |  {{  $i18n.t('trainer.trainer_gameFormSetting_dictation')  }}
                    .form__field-body
                        cs-checkbox(v-model="params.dictation", @change="dictationClicked", :disabled="isMultiplayer")
                .form__field(v-if="gameMode  !==  'generator-settings'")
                    label.form__label
                        |  {{  $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer')  }}
                    .form__field-body
                        cs-multiselect(
                            :options="amountOfSeconds()",
                            v-model="params.timeForAnswer"
                            :placeholder="secondsLabel(params.timeForAnswer)"
                            :multiple="false"
                            :allow-empty="false"
                            :custom-label="secondsLabel"
                        )
                .form__field(v-if="params.operations.divide && !params.operations.multiply")
                    label.form__label
                        |  {{ $i18n.t('trainer.trainer_gameFormSettingDivision_mode') }}
                    .form__field-body
                        cs-multiselect(
                            :options="divisionModes",
                            v-model="params.divMode",
                            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseModeForDivision')"
                            :multiple="false"
                            :allow-empty="true"
                            :custom-label="divisionMode"
                            :show-labels='false',
                        )
                .form__field.checkbox
                    label.form__label.checkbox__label
                            |  {{  $i18n.t('trainer.trainer_gameFormSetting_positiveAnswers')  }}
                    .form__field-body
                        cs-checkbox(
                            v-model="params.positiveAnswers",
                        )
                .form__field.checkbox
                    label.form__label.checkbox__label
                            |  {{  $i18n.t('trainer.trainer_gameFormSetting_negativeAnswers')  }}
                    .form__field-body
                        cs-checkbox(
                            v-model="params.negativeAnswers"
                        )
                .form__field.checkbox
                    label.form__label.checkbox__label
                            |  {{ $i18n.t('trainer.trainer_gameFormSetting_showAnswer') }}
                    .form__field-body
                        cs-checkbox(
                            v-model="params.showAnswer"
                            :checked="params.showAnswer"
                        )
            divider
            .row
                .col-md-5.col-xs-12
                    .divisible-multiplier
                        span
                            template(v-if='params.numbers.length  ===  0')
                                |   {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier')  }}
                            template(v-else='')
                                |   {{ $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier') }}
                    .form__field_columns.select-numeral
                        cs-checkbox(
                            v-model="params.fractions.left",
                            :disabled="params.numbers.length !== 0 || !!params.divMode"
                        )
                            |   {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}
                        .form__field-body
                            .select-container(v-if="params.fractions.left")
                                .select-container__label
                                    span
                                        |   {{ $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints') }}
                                cs-select(
                                    :options="2",
                                    v-model="params.fractionalPart.left",
                                    placeholder="",
                                )
                    .form__field_columns.form__field_numbers
                        template(v-for='(number,  index)  in  numbers')
                            cs-checkbox.checkbox-for-numbers(
                                :checked="params.numbers && params.numbers.includes(number)",
                                @change="setNumber(number)"
                                :disabled="isDisabledNumbers(number)"
                            )
                                |   {{ number }}
                    .form__field--column
                        template(v-for='(value,  key)  in  digitCapacity')
                            cs-checkbox(
                                :checked="params.digitCapacity.left && params.digitCapacity.left.includes(+key)",
                                @change="setKey('left', +key)"
                                @click="params.digitCapacity.left = []"
                                :disabled="isDisabledDigitCapacity(key)"
                            )
                                |   {{  value  }}

                    span.help.is-danger(v-show="errors.has('left')")
                        |  {{  $i18n.t('trainer.trainer_gameFormSetting_select')  }}
                        template(v-if='params.numbers.length  ===  0')
                            |  {{  $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier')  }}
                        template(v-else='')
                            |  {{  $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier')  }}
                .col-md-3.col-xs-12
                    .divisible-multiplier
                        span.column-name
                            |  {{  $i18n.t('trainer.trainer_gameFormSetting_operations')  }}
                    .form__field_operations
                        .form__field-body.multiplication-division
                            cs-checkbox(
                                v-model="params.operations.multiply"
                            )
                                |   {{  $i18n.t('trainer.trainer_gameFormSetting_operationMultiply')  }}
                        .form__field-body.multiplication-division
                            cs-checkbox(
                                v-model='params.operations.divide'
                            )
                                |   {{  $i18n.t('trainer.trainer_gameFormSetting_operationDivide')  }}
                    span.help.is-danger(v-show="errors.has('operations')")
                        |  {{  $i18n.t('trainer.trainer_gameFormErrors_chooseOperation')  }}
                .col-md-4.col-xs-12
                    .divisible-multiplier
                        span.column-name
                            template(v-if='params.numbers.length  ===  0')
                                |  {{  $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier')  }}
                            template(v-else)
                                |  {{  $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier')  }}
                    .form__field_columns.select-numeral
                        cs-checkbox(
                            v-model='params.fractions.right',
                            :disabled='rightFractionsDisabled'
                        )
                            |   {{  $i18n.t('trainer.trainer_gameFormSetting_fractions')  }}
                        .select-container(v-if='params.fractions.right')
                            .select-container__label
                                span
                                    |  {{  $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints')  }}
                            cs-select.select-container__select(
                                v-model='params.fractionalPart.right',
                                :options='+params.fractionalPart.left',
                                placeholder=''
                            )
                    .form__field--column
                        template(v-for='(value,  key)  in  digitCapacity')
                            cs-checkbox(
                                :checked='params.digitCapacity.right && params.digitCapacity.right.includes(+key)'
                                @change="setKey('right', +key)"
                                :disabled="rightDigitCapacityDisabled(key)"
                                @click='!isDisabled(key)  &&  (params.digitCapacity.right  =  [])',
                            )
                                |   {{  value  }}
                        cs-checkbox(
                            v-model='params.tabulatedValue'
                            :disabled="this.params.digitCapacity.left.length !== 0"
                        )
                            |  {{  $i18n.t('trainer.trainer_gameFormSetting_tableValue')  }}
                    span.help.is-danger(v-show="errors.has('right')")
                        |  {{  $i18n.t('trainer.trainer_gameFormSetting_select')  }}
                        template(v-if='params.numbers.length  ===  0')
                            |  {{  $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier')  }}
                        template(v-else='')
                            |  {{  $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier')  }}
            slot(name='parameters')
            slot(name='help')
            .buttons-container
                cs-button.button.is-outlined.is-info(type="button", @click='cancel' pattern="primary-outline", color="blue")
                    |  {{  $i18n.t('trainer.trainer_gameFormSetting_dontSave')  }}
                cs-button.button.is-info(type="button", @click='validateBeforeSave', color="blue")
                    |  {{  $i18n.t('trainer.trainer_gameFormSetting_saveGame')  }}
</template>

<script>
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';
    import disableDictationForMultiplayer from '../../../utils/multiplayer/disableDictationForMultiplayer';
    import TrainerGames from '../../../config/trainer';
    import { mapState } from 'vuex';
    import _ from 'lodash';

    import { getInitParameters } from '../../../utils/trainer/getInitParameters';

    export default {
        props: [
            'gameMode',
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameId',
            'generatorSettings',
            'generatorGameIndex',
        ],
        mixins: [GameFormMixin, multiplayerFormMixin, disableDictationForMultiplayer],
        data() {
            return {
                numbers: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                capacity: [1, 2, 3, 4, 5, 6, 7, 8],
                examples: 100,
                modes: [
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbacus'),
                        value: 'На счетах',
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_inMind'),
                        value: 'В уме',
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_any'),
                        value: 'Любой',
                    },
                ],
                divisionModes: [
                    'withoutReturns',
                    'withOneReturn',
                    'withTwoReturns',
                    'firstDigitsAreSame',
                    'firstDigitsAreOne',
                ],
                digitCapacity: {
                    1: this.$i18n.t('common.common_gameSetting_digitCapacity1'),
                    2: this.$i18n.t('common.common_gameSetting_digitCapacity2'),
                    3: this.$i18n.t('common.common_gameSetting_digitCapacity3'),
                    4: this.$i18n.t('common.common_gameSetting_digitCapacity4'),
                    5: this.$i18n.t('common.common_gameSetting_digitCapacity5'),
                    6: this.$i18n.t('common.common_gameSetting_digitCapacity6'),
                    7: this.$i18n.t('common.common_gameSetting_digitCapacity7'),
                    8: this.$i18n.t('common.common_gameSetting_digitCapacity8'),
                },
                params: null,
                games: _.cloneDeep(TrainerGames.games),
            };
        },
        mounted() {
            if (this.isGeneratorSettings) {
                if (this.homework && this.homework.grades && this.homework.grades.length) {
                    let currentGameSettings = this.homework.grades[0].course.games.find(element => element.slug == this.slug);
                    this.gamesParameters[this.slug] = currentGameSettings.parameters.default;
                }
            }
            if(this.homework && this.homework.courses) {
                let copyCourses = this.homework.courses.filter(course => course.games.find(element => element.slug == this.slug));
                copyCourses.sort((a, b) => a.level - b.level);
                let currentGameSettings = copyCourses[0].games.find(element => element.slug == this.slug);
                this.gamesParameters[this.slug] = currentGameSettings.parameters.default;
            }
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.params = getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: this.gamesParameters[this.slug],
                        },
                    });
                } else {
                    this.params = _.find(this.games, { slug: this.slug }).parameters.default;
                }
                this.params.infinityAmountOfExamples = true;
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            if (!this.params.fractions) {
                this.params.fractions = {};
            }
        },
        watch: {
            'params.digitCapacity.left': {
                handler(val) {
                    if (_.isEmpty(val) && _.isEmpty(this.params.numbers)) {
                        this.$validator.attach('left', 'required');
                    } else if (val[0]) {
                        this.$validator.detach('left');
                        this.params.numbers = [];
                        this.params.tabulatedValue = false;
                        val[0] < this.params.digitCapacity.right[0] && (this.params.digitCapacity.right[0] = val[0]);
                    }
                },
            },
            'params.digitCapacity.right': {
                handler(val) {
                    if (_.isEmpty(val)) {
                        this.params.tabulatedValue
                            ? this.$validator.detach('right')
                            : this.$validator.attach('right', 'required');
                    } else if (val[0]) {
                        this.$validator.detach('right');
                        this.params.tabulatedValue = false;
                    }
                },
            },
            'params.tabulatedValue': {
                handler(val) {
                    if (val) {
                        this.params.digitCapacity.right = [];
                    } else if (_.isEmpty(this.params.digitCapacity.right)) {
                        this.$validator.attach('right', 'required');
                    }
                },
            },
            'params.operations': {
                handler(val) {
                    if (val.multiply || val.divide) {
                        this.$validator.detach('operations');
                    } else {
                        this.$validator.attach('operations', 'required');
                    }
                    if (!val.divide) {
                        this.params.divMode = false;
                    }
                },
                deep: true,
            },
            'params.numbers': {
                handler(val) {
                    if (!_.isEmpty(val)) {
                        this.$validator.detach('left');
                    }
                    if (val && val.length) {
                        this.params.fractions.left = false;
                        if (+this.params.digitCapacity.right[0] === 1) {
                            this.params.digitCapacity.right = [];
                        }
                    }
                },
            },
            rightFractionsDisabled: {
                handler(val) {
                    if (val) {
                        this.params.fractions.right = false;
                    }
                },
            },
            'params.fractions.right': {
                handler(val) {
                    if (val && this.params.tabulatedValue) {
                        this.params.tabulatedValue = false;
                    }
                },
            },
            'params.fractionalPart.left': {
                handler() {
                    this.params.fractionalPart.right = 1;
                },
            },
            'params.dictation'(val) {
                if (val) {
                    this.params.infinityAmountOfExamples = false;
                }
            },
            'params.divMode'(val) {
                val && (this.params.digitCapacity.right[0] = 2) && (this.params.digitCapacity.left[0] = 3);
            },
        },
        computed: {
            ...mapState({
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
            isGeneratorSettings () {
              if (this.gameMode == 'generator-settings' && this.gamesParameters) {
                return false;
              }
              return false;
            },
            rightFractionsDisabled() {
                return this.params && (this.params.numbers.length !== 0 || !this.params.fractions.left);
            },
            positiveAnswersDisabled() {
                return this.params.positiveAnswers && !this.params.negativeAnswers;
            },
            negativeAnswersDisabled() {
                return this.params.negativeAnswers && !this.params.positiveAnswers;
            },
        },
        methods: {
            isDisabledNumbers (number) {
                if (this.isGeneratorSettings) {
                    let isDisabled = Boolean(this.gamesParameters[this.slug].numbers.find(element => element == number));
                    return !isDisabled;
                }
                return !!this.params.divMode;
            },
            isDisabledDigitCapacity (key) {
                if (this.isGeneratorSettings) {
                    let isDisabled = Boolean(this.gamesParameters[this.slug].digitCapacity.left.find(element => element == key));
                    return !isDisabled;
                }
                return this.leftDigitCapacityDisabled(key);
            },
            divisionMode(mode) {
                return this.$i18n.t(`trainer.trainer_gameFormSettingDivision_${mode}`);
            },
            dictationClicked() {
                this.params.timeForAnswer = this.params.dictation ? 1 : '-1';
            },
            isDisabled(value) {
                return this.params.numbers.length === 0 && this.params.digitCapacity.left[0] < value;
            },
            validateBeforeSave() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        if (this.usersIds) {
                            this.saveGame();
                        } else if (this.gameMode === 'free-game') {
                            this.saveGameMode();
                        } else {
                            this.saveGame();
                        }
                    }
                });
            },
            rightDigitCapacityDisabled(index) {
                return (
                    !!this.params.divMode ||
                    (this.params.numbers.length === 0 && this.params.digitCapacity.left[0] < index) ||
                    (+index === 1 && this.params.numbers.length !== 0)
                );
            },
            leftDigitCapacityDisabled(index) {
                return this.params.divMode && +index < 3;
            },
            selectMode(mode) {
                this.params.mode = mode.value;
            },
            amountOfSeconds() {
                if (!this.params.dictation) {
                    let array = Array.from(Array(100), (_, i) => i + 1);
                    array.unshift(Number('-1'));
                    return array;
                }
                return Array.from(Array(100), (_, i) => i + 1);
            },
            secondsLabel(amount) {
                if (!this.params.dictation) {
                    return amount == -1
                        ? this.$i18n.t('trainer.trainer_gameFormSettingValue_off')
                        : amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
                }
                return amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
            },
            setNumber(number) {
                if (this.params.numbers.includes(number)) {
                    this.params.numbers.splice(this.params.numbers.indexOf(number), 1);
                } else {
                    this.params.numbers.push(number);
                }
                this.params.digitCapacity.left = [];
            },
            setKey(key, value) {
                if (this.params.digitCapacity[key].includes(value)) {
                    this.params.digitCapacity[key].splice(this.params.digitCapacity[key].indexOf(value), 1);
                } else {
                    this.params.digitCapacity[key] = [];
                    this.params.digitCapacity[key].push(value);
                }
            },
            decreaseExamples() {
                if (
                    this.params.amountOfExamples !== 1 &&
                    !this.params.timeLimit &&
                    !this.params.infinityAmountOfExamples
                ) {
                    this.params.amountOfExamples -= 1;
                }
            },
            increaseExamples() {
                if (
                    this.params.amountOfExamples !== this.examples &&
                    !this.params.timeLimit &&
                    !this.params.infinityAmountOfExamples
                ) {
                    this.params.amountOfExamples += 1;
                }
            },
        },
    };
</script>

<style scoped lang="scss">
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        max-width: 1020px;
        margin: 0 auto;
        box-sizing: border-box;
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .form__field_columns {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
    }

    .form__field_numbers {
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        @include media($xl) {
            width: 250px;
        }
        @include media($xlg) {
            width: 280px;
        }
    }

    .form__field--column {
        flex-direction: column;
        @include stack-space($space-base);
        align-items: flex-start;
    }

    .form__input {
        margin-bottom: 0;
    }

    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__field_operations {
        display: flex;
        @media screen and (max-width: 767px) {
            :first-child {
                flex-grow: 0;
                margin-right: 10px;
            }
        }
        @include media($md) {
            display: block;
        }
    }

    .form-container__select {
        width: 100%;
        max-width: 300px;
        @media screen and (max-width: 767px) {
            max-width: none;
        }
    }

    .form-container__select-examples {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        @media screen and (min-width: 700px) {
            flex-direction: row;
            align-items: center;
        }
    }

    .form-container__select-infinity-mode {
        display: flex;
        align-items: center;
        margin-top: 20px;
        @media screen and (min-width: 700px) {
            margin-top: 0;
        }
    }

    .form-container__checkbox {
        margin-left: 30px;
    }

    .form-container__svg-icon {
        opacity: 0.7;
        margin: 0 10px 10px 0;
    }

    .col-md-4:first-child {
        @media screen and (min-width: 740px) {
            padding-right: 30px;
        }
        .form__field--column {
            @media screen and (min-width: 768px) and (max-width: 850px) {
                width: 180px;
            }
        }
    }

    .col-md-4:last-child {
        .form__field--column {
            @media screen and (min-width: 768px) and (max-width: 820px) {
                font-size: 14px;
            }
        }
    }

    .checkbox-container {
        display: flex;
        flex-direction: column;
        label {
            padding-bottom: 0 !important;
        }
        @include stack-space($space-base);
    }

    .checkbox-for-numbers {
        margin-right: 15px;
        margin-bottom: $space-small !important;
    }

    .divisible-multiplier {
        margin: 10px 5px;
    }

    .multiplication-division {
        @include stack-space($space-small);
    }

    .select-numeral {
        flex-direction: column;
        align-items: flex-start;
    }

    .select-container__label {
        margin: 10px 0 5px;
    }

    .buttons-container {
        display: flex;
        justify-content: center;
        margin: 20px;
        flex-direction: column;
        @include media($sm) {
            flex-direction: row;
        }
    }

    .button.is-info {
        height: 100% !important;
        font-size: $font-size-16;
        &:first-child {
            margin-bottom: 20px;
            @include media($sm) {
                margin: 0 5px;
            }
        }
        @include media($md) {
            font-size: $font-size-16;
            margin: 0 15px;
        }
    }

    .help {
        &.is-danger {
            color: #ff3d53;
        }
    }

    .checkbox {
        @media screen and (max-width: 767px) {
            flex-direction: row;
        }
    }

    .checkbox__label {
        @media screen and (max-width: 767px) {
            margin-bottom: 0;
            display: flex;
            align-items: center;
        }
    }
</style>
